{
  "form": {
    "error-header": {
      "errors": "There are errors in the following section(s): {{sections}}",
      "errors_with_others": "There are errors in the following sections: {{sections}} and $t(form.error-header.sections, {\"count\": {{otherCount}} }).",
      "sections_one": "{{count}} other section",
      "sections_other": "{{count}} other sections"
    },
    "sections": {
      "navigation_title": "Listing Profile Sections",
      "general_information": "General Information",
      "accreditation": "Accreditation",
      "teaching_experience": "Teaching Experience",
      "self_assessment": "Self-assessment",
      "listing_details": "Listing Details",
      "listing_tags": "Listing Tags"
    },
    "general_information_section": {
      "subsections": {
        "personal_information": "Personal Information",
        "residential_address": "Residential Address",
        "personal_background_video": "Personal Background Video"
      },
      "personal_information": {
        "photo_id": "Photo ID",
        "photo_id_alt": "Photo ID",
        "first_name": "First Name",
        "last_name": "Last Name",
        "date_of_birth": "Date of Birth",
        "gender": "Gender",
        "religion": "Religion",
        "race": "Race",
        "primary_language": "Primary Language",
        "secondary_language": "Secondary Language",
        "citizenship": "Citizenship",
        "mobile_number": "Mobile Number",
        "country_of_origin": "Country of origin",
        "placeholders": {
          "select_religion": "Select religion",
          "select_race": "Select race",
          "select_primary_language": "Select primary language",
          "select_secondary_language": "Select secondary language",
          "select_citizenship_countries": "Select citizenship countries",
          "select_country_of_origin": "Select country of origin"
        },
        "tooltips": {
          "religion": "Religion according to <a>Australian Standard Classification of Religious Groups</a>",
          "race": "Race according to <a>Australian Standard Classification of Cultural and Ethnic Groups</a>",
          "country": "Country according to <a>Standard Australian Classification of Countries</a>",
          "language": "Language according to <a>Australian Standard Classification of Languages</a>"
        },
        "validation": {
          "mobile_number_invalid": "Please enter a valid mobile number.",
          "citizenship_max_two": "You can only select a maximum of 2 citizenships."
        }
      },
      "residential_address": {
        "country_of_residence": "Country of residence",
        "state_of_residence": "State of residence",
        "address_1": "Address 1",
        "address_2": "Address 2",
        "suburb": "Suburb",
        "postcode": "Postcode",
        "placeholders": {
          "select_country_of_residence": "Select country of residence",
          "select_state_of_residence": "Select state of residence"
        },
        "validation": {
          "postcode_format": "Postcode must be 4 digits and numeric"
        }
      },
      "personal_background_video": {
        "background_video_link": "Background Video Link",
        "background_video_placeholder": "https://www.youtube.com/watch?v=..."
      }
    },
    "accreditation_section": {
      "subsections": {
        "other_accreditation": "Other Accreditation",
        "state_accreditation": "State Accreditation"
      },
      "other_accreditation": {
        "description": "e.g. for Mature Entrants",
        "title": "Other Accreditation {{index}}",
        "registration_number": "Registration Number",
        "registration_number_placeholder": "Enter registration number",
        "description_label": "Description",
        "description_placeholder": "Enter description",
        "accreditation_file": "Accreditation File",
        "remove_aria_label": "Remove Other Accreditation {{index}}",
        "remove_attachment_aria_label": "Remove Accreditation File",
        "add_button": "Add Other Accreditation"
      },
      "state_approvals": {
        "vic_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Victoria",
        "nsw_approval": "$t(form.accreditation_section.state_approvals.rego_number) - New South Wales",
        "qld_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Queensland",
        "wa_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Western Australia",
        "sa_approval": "$t(form.accreditation_section.state_approvals.rego_number) - South Australia",
        "tas_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Tasmania",
        "nt_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Northern Territory",
        "act_approval": "$t(form.accreditation_section.state_approvals.rego_number) - Australian Capital Territory",
        "rego_number": "Registration Number",
        "rego_number_placeholder": "Enter registration number"
      }
    },
    "teaching_experience_section": {
      "subsections": {
        "qualifications": "Qualifications",
        "subject_experience": "Subject Experience",
        "work_experience": "Work Experience",
        "memberships": "Memberships",
        "types_of_students_taught": "Types of Students Taught",
        "other_experience": "Other Experience",
        "resume": "Resume"
      },
      "qualifications": {
        "title": "Qualification {{index}}",
        "qualification": "Qualification",
        "university_name": "University Name",
        "year_obtained": "Year obtained",
        "qualification_placeholder": "Enter qualification",
        "university_name_placeholder": "Enter university name",
        "year_obtained_placeholder": "Enter year",
        "remove_aria_label": "Remove Qualification {{index}}",
        "add_button": "Add Qualification"
      },
      "subject_experience": {
        "title": "Subject Experience {{index}}",
        "subject": "Subject",
        "year_level": "Year Level",
        "from_year": "From Year",
        "to_year": "To Year",
        "subject_placeholder": "Select subject",
        "year_level_placeholder": "Select year level",
        "from_year_placeholder": "Enter from year",
        "to_year_placeholder": "Enter to year",
        "remove_aria_label": "Remove Subject Experience {{index}}",
        "add_button": "Add Subject Experience"
      },
      "work_experience": {
        "title": "Work Experience {{index}}",
        "role": "Title",
        "company_name": "Company Name",
        "from_year": "From Year",
        "to_year": "To Year",
        "company_name_placeholder": "Enter company name",
        "title_placeholder": "Enter title",
        "from_year_placeholder": "Enter from year",
        "to_year_placeholder": "Enter to year",
        "remove_aria_label": "Remove Work Experience {{index}}",
        "add_button": "Add Work Experience"
      },
      "memberships": {
        "title": "Membership {{index}}",
        "membership": "Membership",
        "link": "Link",
        "membership_placeholder": "Enter membership organization",
        "link_placeholder": "Enter link",
        "remove_aria_label": "Remove Membership {{index}}",
        "add_button": "Add Membership"
      },
      "types_of_students_taught": {
        "gender": "Gender",
        "gender_notes": "Gender Notes",
        "religion": "Religion",
        "religion_notes": "Religion Notes",
        "primary_language": "Primary Language",
        "primary_language_notes": "Primary Language Notes",
        "secondary_language": "Secondary Language",
        "secondary_language_notes": "Secondary Language Notes",
        "eyesight": "Eyesight",
        "eyesight_notes": "Eyesight Notes",
        "adhd": "ADHD",
        "adhd_notes": "ADHD Notes",
        "depression": "Depression",
        "depression_notes": "Depression Notes",
        "intellectual_ability_notes": "Intellectual Ability Notes",
        "socioeconomic_notes": "Socioeconomic Notes",
        "other_notes": "Other Notes",
        "gender_placeholder": "Select gender options",
        "religion_placeholder": "Select religion options",
        "primary_language_placeholder": "Select primary language options",
        "secondary_language_placeholder": "Select secondary language options",
        "eyesight_placeholder": "Select eyesight options",
        "adhd_placeholder": "Select ADHD options",
        "depression_placeholder": "Select depression options",
        "gender_notes_placeholder": "Enter gender notes",
        "religion_notes_placeholder": "Enter religion notes",
        "primary_language_notes_placeholder": "Enter primary language notes",
        "secondary_language_notes_placeholder": "Enter secondary language notes",
        "eyesight_notes_placeholder": "Enter eyesight notes",
        "adhd_notes_placeholder": "Enter ADHD notes",
        "depression_notes_placeholder": "Enter depression notes",
        "intellectual_ability_notes_placeholder": "Enter intellectual ability notes",
        "socioeconomic_notes_placeholder": "Enter socioeconomic notes",
        "other_notes_placeholder": "Enter other notes",
        "options": {
          "gender": {
            "male": "Male",
            "female": "Female",
            "other": "Other"
          },
          "eyesight": {
            "normal_vision": "Normal vision",
            "glasses": "Glasses",
            "contact_lenses": "Contact lenses",
            "vision_impaired": "Vision impaired"
          },
          "adhd": {
            "yes": "Yes",
            "no": "No"
          },
          "depression": {
            "yes": "Yes",
            "no": "No"
          }
        }
      },
      "other_experience": {
        "assessor_experience": "Assessor Experience",
        "examiner_experience": "Examiner Experience",
        "assessor_title": "Assessor Experience {{index}}",
        "examiner_title": "Examiner Experience {{index}}",
        "subject": "Subject",
        "state": "State",
        "from_year": "From Year",
        "to_year": "To Year",
        "subject_placeholder": "Enter subject",
        "state_placeholder": "Enter state",
        "from_year_placeholder": "Enter from year",
        "to_year_placeholder": "Enter to year",
        "remove_assessor_aria_label": "Remove Assessor Experience {{index}}",
        "remove_examiner_aria_label": "Remove Examiner Experience {{index}}",
        "add_assessor_button": "Add Assessor Experience",
        "add_examiner_button": "Add Examiner Experience"
      },
      "resume": {
        "remove_resume_aria_label": "Remove Resume",
        "resume_file": "Resume File"
      }
    },
    "self_assessment_section": {
      "title": "Self-assessment",
      "teaching_styles": {
        "autocratic": "Autocratic",
        "reserved": "Reserved",
        "talk": "Chalk/talk",
        "consultative": "Consultative",
        "participative": "Participative"
      },
      "teaching_style_comment": "Teaching Style Comments",
      "teaching_style_comment_placeholder": "Enter your teaching style comments",
      "rating_scale": {
        "1": "1 - Never",
        "2": "2 - Rarely",
        "3": "3 - Sometimes",
        "4": "4 - Often",
        "5": "5 - Always"
      }
    },
    "listing_details_section": {
      "visibility": {
        "title": "Invite Only",
        "public": "Anyone can request to join",
        "public_description": "Teachers can request to join your team.",
        "private": "Invite Only",
        "private_description": "Teachers cannot request to join your team."
      },
      "classes_listing_type": {
        "title": "Classes Listing Type",
        "shared": "Shared Classes",
        "shared_description": "Create shared classes where student preferences are distributed according to your team's tier system. You control allocation priority and how preferences flow from tier to tier as classes fill up.",
        "separate": "Separate Classes",
        "separate_description": "Each team member creates their own classes. Students can choose specific teachers and book directly with them."
      },
      "name": "Listing Name",
      "webpage_url": "Webpage Url",
      "written_comment": "Listing Description",
      "video_url": "Video Url",
      "title": "Listing Details"
    },
    "listing_tags_section": {
      "description": "Add tags to your listing to help teachers find it."
    }
  },
  "new": {
    "title": "New Team Listing",
    "submit": "Create Team Listing"
  },
  "edit": {
    "title": "Edit Listing Profile",
    "submit": "Update Listing Profile"
  }
}
